// Web: load the bundled Poppins and DM Sans files (served from our own origin, constitution VI) with
// `font-display: swap`, so text shows at once in the system sans fallback and swaps when the font
// arrives (FR-021; R7). Only the weights in use are imported, so only those are bundled.
import { DMSans_400Regular } from "@expo-google-fonts/dm-sans/400Regular";
import { DMSans_500Medium } from "@expo-google-fonts/dm-sans/500Medium";
import { DMSans_600SemiBold } from "@expo-google-fonts/dm-sans/600SemiBold";
import { DMSans_700Bold } from "@expo-google-fonts/dm-sans/700Bold";
import { Poppins_500Medium } from "@expo-google-fonts/poppins/500Medium";
import { Poppins_600SemiBold } from "@expo-google-fonts/poppins/600SemiBold";
import { Poppins_700Bold } from "@expo-google-fonts/poppins/700Bold";
import { FontDisplay, useFonts } from "expo-font";

import { tokens } from "./tokens";

const swap = (uri: number) => ({ uri, display: FontDisplay.SWAP });

const webFonts = {
  [tokens.font.heading.medium]: swap(Poppins_500Medium),
  [tokens.font.heading.semiBold]: swap(Poppins_600SemiBold),
  [tokens.font.heading.bold]: swap(Poppins_700Bold),
  [tokens.font.body.regular]: swap(DMSans_400Regular),
  [tokens.font.body.medium]: swap(DMSans_500Medium),
  [tokens.font.body.semiBold]: swap(DMSans_600SemiBold),
  [tokens.font.body.bold]: swap(DMSans_700Bold),
};

/** Never blocks the first render on the web: the fallback shows until the fonts swap in. */
export function useAppFonts(): boolean {
  useFonts(webFonts);
  return true;
}

/** CSS font-family list: the bundled family, then the system sans stack while it loads. */
export function withFallback(family: string): string {
  return `${family}, ${tokens.font.fallback}`;
}
